import React from "react";

import { useIntl } from "react-intl";

import ShapeKey from "./ShapeKey";

interface Props {}

const NoShapeKey: React.FC<Props> = () => {
  const intl = useIntl();
  return (
    <ShapeKey>
      {intl.formatMessage({
        id: "map.layer.shapeKey.legend.noShape.description",
        defaultMessage: "Shape customization is not applied, using a default marker shape.",
        description: "Description of the No Shape legend",
      })}
    </ShapeKey>
  );
};

export default NoShapeKey;
